// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var TipIsSymbol = {
    reflectSymbol: function () {
        return "Tip";
    }
};
var Tip = /* #__PURE__ */ (function () {
    function Tip(value0) {
        this.value0 = value0;
    };
    Tip.create = function (value0) {
        return new Tip(value0);
    };
    return Tip;
})();
var toFillFormTypeTip = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqTip = {
    eq: function (x) {
        return function (y) {
            return eq(x.value0)(y.value0);
        };
    }
};
var genericTip = {
    to: function (x) {
        return new Tip(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var showTip = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericTip)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Money_Rounded.showMoney))(TipIsSymbol))
};
var unscrambleDecodeTip = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericTip)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(TipIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Data_Money_Rounded.udecodeMoney)))(Unscramble_Generic.defaultOptions)
};
var encodingOptsTip = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform,
        unwrapSingleConstructors: true,
        unwrapSingleRecordArguments: true
    };
})();
var encodeTip = /* #__PURE__ */ (function () {
    return {
        encode: Foreign_Generic.genericEncode(genericTip)(Foreign_Generic_Class.genericEncodeConstructor(TipIsSymbol)(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))({
            sumEncoding: encodingOptsTip.sumEncoding,
            unwrapSingleArguments: encodingOptsTip.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOptsTip.unwrapSingleRecordArguments,
            fieldTransform: encodingOptsTip.fieldTransform,
            unwrapSingleConstructors: false
        })
    };
})();
var decodeTip = /* #__PURE__ */ (function () {
    return {
        decode: Foreign_Generic.genericDecode(genericTip)(Foreign_Generic_Class.genericDecodeConstructor(TipIsSymbol)(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney)))(Foreign_Generic_Class.genericCountArgsArgument))({
            sumEncoding: encodingOptsTip.sumEncoding,
            unwrapSingleArguments: encodingOptsTip.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOptsTip.unwrapSingleRecordArguments,
            fieldTransform: encodingOptsTip.fieldTransform,
            unwrapSingleConstructors: false
        })
    };
})();
export {
    encodingOptsTip,
    Tip,
    genericTip,
    eqTip,
    showTip,
    encodeTip,
    decodeTip,
    unscrambleDecodeTip,
    toFillFormTypeTip
};
